import axios from "axios";
import { getEnvVar } from "utils/env";
import { getRefreshToken, processTokenError, authorizeRequest, doRefreshToken, canRefreshToken } from "./sessionUtils";

axios.defaults.baseURL = getEnvVar("REACT_APP_API_URL");
axios.defaults.headers.common["Content-Type"] = "application/json";

const client = axios.create();

// Request interceptor for API calls
client.interceptors.request.use(async (config) => {
    return authorizeRequest(config);
}, Promise.reject);

// Response interceptor for API calls
client.interceptors.response.use(
    (response) => response,
    async function (error) {
        const originalRequest = error.config;
        if (error.response.status === 403 && !originalRequest._retry) {
            if (canRefreshToken(originalRequest.url)) {
                originalRequest._retry = true;
                const rt = getRefreshToken();
                if (rt) {
                    axios.defaults.headers.common["Authorization"] = await doRefreshToken(rt, post);
                    return client(originalRequest);
                }
                return processTokenError(error);
            }
            return processTokenError(error);
        }
        return Promise.reject(error);
    }
);

export async function get({ url, data }) {
    const response = await client.get(url, { params: data });
    return response;
}

export async function post({ url, data }) {
    const response = await client.post(url, data);
    return response;
}

export async function put({ url, data }) {
    const response = await client.put(url, data);
    return response;
}

export async function deleteAll({ url, data }) {
    const response = await client.delete(url, { data });
    return response;
}

export async function patch({ url, data }) {
    const response = await client.patch(url, data);
    return response;
}
